import styled from "styled-components";
import ResultBanner from "../../assets/images/sgb/result_banner.png";

export const Wrapper = styled.div`
  background: #f4f4f4;
`;

export const Container = styled.div`
  .banner {
    width: 100%;
    display: block;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 4rem;
    background: url(${ResultBanner}) no-repeat;
    background-size: 100%;
    padding-top: 0.7rem;
    p {
      height: 0.38rem;
      font-size: 0.4rem;
      font-weight: 300;
      color: #ffffff;
      line-height: 0.38rem;
      text-align: center;
    }
    span {
      height: 0.54rem;
      font-size: 0.72rem;
      font-weight: 600;
      color: #ffffff;
      line-height: 0.54rem;
      display: block;
      text-align: center;
      margin-top: 0.25rem;
    }
  }
  .main {
    padding: 0 0.3rem;
    .center {
      height: 10.15rem;
      background: #ffffff;
      border-radius: 0.1rem;
      margin-top: -1rem;
      position: relative;
      z-index: 2;
      .content {
        display: flex;
        padding: 0 0.3rem;
      }
      .title {
        font-size: 0.22rem;
        font-weight: 300;
        color: #999999;
        line-height: 0.3rem;
        margin-top: 0.7rem;
        padding: 0 0.2rem;
      }
      .times {
        height: 7.72rem;
        margin-top: 0.4rem;
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        div {
          flex: 1;
          color: #999999;
          p {
            height: 0.27rem;
            font-size: 0.28rem;
            line-height: 0.27rem;
            text-align: right;
          }
          span {
            height: 0.22rem;
            font-size: 0.28rem;
            line-height: 0.22rem;
            display: block;
            margin-top: 0.1rem;
          }
        }
        .active {
          color: #fb7b00;
        }

        div:nth-child(2) {
          p {
            margin-top: -0.1rem;
          }
        }
        div:nth-child(3) {
          p {
            margin-top: -0.2rem;
          }
        }
        div:last-child {
          position: absolute;
          bottom: 0.02rem;
        }
      }
      .under {
        width: 0.5rem;
        height: 7.5rem;
        position: relative;
        margin: 0.6rem 0.2rem 0 0.1rem;
        .def {
          width: 1px;
          height: 7.3rem;
          background: #dddddd;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }
        .os {
          width: 0.22rem;
          height: 7.3rem;
          margin: 0 auto;
          top: -7.3rem;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          position: relative;
          z-index: 2;
          p {
            flex: 1;
            position: relative;
            span {
              width: 0.21rem;
              height: 0.21rem;
              border-radius: 50%;
              background: #dddddd;
              display: block;
              position: relative;
            }
            span.active {
              background: #fb7b00;
            }
          }
          p:last-child {
            position: absolute;
            bottom: 0;
          }
        }
        .on {
          width: 0.5rem;
          height: 7.5rem;
          margin: 0 auto;
          top: -14.6rem;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          position: relative;
          z-index: 3;
          span {
            width: 0.2rem;
            height: 0.2rem;
            border-radius: 50%;
            background: #fb7b00;
            display: block;
            position: relative;
            margin: 0 auto;
          }
          p {
            width: 0.06rem;
            background: #fb7b00;
            margin: 0 auto;
            transition: all 2s;
          }
          b {
            width: 0.5rem;
            height: 0.5rem;
            background: #ffffff;
            border: 0.06rem solid #fb7b00;
            border-radius: 50%;
            font-size: 0.24rem;
            font-weight: 300;
            color: #fb7b00;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .msg {
        flex: 1;
        height: 7.6rem;
        margin-top: 0.6rem;
        .card {
          height: 1.9rem;
          background: #ffffff;
          width: 100%;
          box-shadow: 0px 0.02rem 0.16rem 0.02rem rgba(81, 78, 107, 0.1);
          border-radius: 0.1rem;
          opacity: 0;
          transition: all 2s;
          position: relative;
          div {
            height: 0.7rem;
            font-size: 0.28rem;
            font-weight: 300;
            color: #fb7b00;
            line-height: 0.68rem;
            padding: 0 0.22rem;
            border-bottom: 1px solid #eeeeee;
          }
          p {
            height: 0.28rem;
            font-size: 0.28rem;
            font-weight: 300;
            color: #666666;
            line-height: 0.28rem;
            padding: 0 0.2rem;
            margin-top: 0.2rem;
            span {
              color: #fb7b00;
            }
          }
          b {
            height: 0.24rem;
            font-size: 0.24rem;
            font-weight: 300;
            color: #666666;
            line-height: 0.24rem;
            display: block;
            padding: 0 0.2rem;
            margin-top: 0.18rem;
            span {
              color: #fb7b00;
            }
          }
        }
        .card.active {
          opacity: 1;
        }
      }
    }
  }
`;
